import { render, staticRenderFns } from "./twoElements.vue?vue&type=template&id=207fd74c&scoped=true"
import script from "./twoElements.vue?vue&type=script&lang=js"
export * from "./twoElements.vue?vue&type=script&lang=js"
import style0 from "./twoElements.vue?vue&type=style&index=0&id=207fd74c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207fd74c",
  null
  
)

export default component.exports